import { VariantType } from 'notistack';

export interface SliceStatus {
  message: string;
  variant: VariantType;
}

export const defaultStatus: SliceStatus = {
  message: '',
  variant: 'default'
};
